import { Injectable } from "@angular/core";
import { LicenseVerificationState } from "../../constants/app.enums";
import { HttpSubscriptionService } from "../../services/http.subsription.service";
import { SignaturesResponse, SubscriptionInfoResponse } from "../response/SubscriptionResponse";

@Injectable({
    providedIn: 'root'
})
export class LicenseManager{
    state: LicenseVerificationState = LicenseVerificationState.NONE
    isUnlimited: boolean = false
    didExceedTrialLimit: boolean = false;
    subscription_info?: SubscriptionInfoResponse
    signatures_response?: SignaturesResponse
    private wasInitialized = false;

    constructor(private subscriptionService: HttpSubscriptionService){}

    public initialize(){
        if(this.wasInitialized){
            return;
        }
        this.getLicense()
    }

    public refreshLicense(){
        this.clearVariables();
        this.getLicense();
    }

    private clearVariables(){
        this.state= LicenseVerificationState.NONE;
        this.isUnlimited = false;
        this.didExceedTrialLimit = false;
        this.subscription_info = undefined;
        this.signatures_response = undefined;
        this.wasInitialized = false;
    }

    private getLicense(){
        this.subscriptionService.getUserLicence().subscribe({
            next: (response) => {
                if(!response.signatures_response.is_unlimited){
                    this.didExceedTrialLimit = response.signatures_response.consumed! >= response.signatures_response.total!;
                    if(this.didExceedTrialLimit){
                        this.state = LicenseVerificationState.EXCEEDED_SUBSCRIPTION_LIMIT;
                    }
                    else{
                        this.state = LicenseVerificationState.HAS_ACTIVE_LICENSE;
                    }
                }
                else{
                    this.isUnlimited = true;
                    this.state = LicenseVerificationState.HAS_ACTIVE_LICENSE;
                }

                this.subscription_info = response.subscription_info;
                this.signatures_response = response.signatures_response;

                this.wasInitialized = true;
            },
            error: (err) => {
                this.handleLicenseError(err);
            },
        });
    }

    public hasUnlimited(){
        return this.isUnlimited
    }

    public getState(){
        return this.state;
    }
    
    public getSubscriptionInfo(){
        return this.subscription_info;
    }
    
    public getSignatures(){
        return this.signatures_response;
    }

    private handleLicenseError(err: any){
        this.state = LicenseVerificationState.NO_ACTIVE_LICENSE;
    }
}